import React from "react";

const MAP = {
  Lead: { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  Qualified: { bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  "Designer Assigned": { bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  "Booking Pending": { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  Booked: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Design: { bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF" },
  Quotation: { bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF" },
  "Design Approval": { bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF" },
  "Commercial Freeze": { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA" },
  Procurement: { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA" },
  Planning: { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA" },
  Execution: { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA" },
  Audit: { bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  Handover: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Warranty: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Completed: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Cancelled: { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
  "On Hold": { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
  Pending: { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  Approved: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Rejected: { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
  Active: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  "In Progress": { bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  Blocked: { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
};

export function StatusBadge({ status, testid }) {
  const s = MAP[status] || { bg: "#EEE9DE", text: "#525252", border: "#E3DAC8" };
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider border"
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      {status}
    </span>
  );
}
